/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

/**
 * Workflow execution status
 */
export type CreateWorkflowDtoStatus = (typeof CreateWorkflowDtoStatus)[keyof typeof CreateWorkflowDtoStatus];

export const CreateWorkflowDtoStatus = {
  ACTIVE: 'active',
  PAUSED: 'paused',
  ATTEMPTS_EXCEEDED: 'attempts_exceeded',
  DISABLED: 'disabled',
} as const;
